<template>
  <div class="leave-word-list">
    <van-row>
      <van-search
          v-model="leaveWordQuery.title"
          show-action
          placeholder="请输入您的问题"
          @search="handleSearchLeaveWord"
          @cancel="handleCancelSearch"/>
    </van-row>
    <van-row class="leave-word-list-content" v-for="(leaveWord,index) in leaveWordList" :key="index"
             @click="handleGoToDetailPage(leaveWord.id)">
      <van-row class="leave-word-list-content-title">
        <div class="top" v-if="leaveWord.topTime">
          <span>置顶</span>
        </div>
        {{ leaveWord.title }}
      </van-row>
      <van-row class="phoneNumber-and-createdDate" type="flex" justify="space-between">
        <van-col>
          <span class="phoneNumber">{{ leaveWord.phoneNumber }}</span>
        </van-col>
        <van-col>
          <span class="createdDate">{{ leaveWord.createdDate }}</span>
        </van-col>
      </van-row>
      <van-divider :style="{borderColor:'#dcdcdc'}"/>
    </van-row>
    <div class="pagination-row" v-if="paginationManager.total > 5">
      <img :src="getPreviousArrowSrc" @click="handlePreviousPage"/>
      <div>{{ paginationManager.currentPage }}/{{ totalPages }}</div>
      <img :src="getNextArrowSrc" @click="handleNextPage"/>
    </div>
  </div>
</template>

<script>
import LeaveWordQuery from "@/leave-word/dto/LeaveWordQuery";
import {PaginationManager} from "@zhoujianhui/vip-core";
import leaveWordService from "@/leave-word/service/leave-word-service";

export default {
  name: "LeaveWordList",
  data() {
    return {
      leaveWordQuery: new LeaveWordQuery(),
      paginationManager: new PaginationManager(null, null, ["topTime,desc", "createdDate,desc"]),
      leaveWordList: [],
      totalPages: 0
    }
  },
  created() {
    this.searchLeaveWords();
  },
  computed: {
    getPreviousArrowSrc() {
      if (this.paginationManager.currentPage !== 1) {
        return require('../images/arrow-left.png');
      } else {
        return require('../images/arrow-left-unactive.png');
      }
    },
    getNextArrowSrc() {
      if (this.totalPages === this.paginationManager.currentPage) {
        return require('../images/arrow-right-unactive.png');
      } else {
        return require('../images/arrow-right.png');
      }
    }
  },
  methods: {
    async searchLeaveWords() {
      const result = await leaveWordService.searchLeaveWords(this.leaveWordQuery, this.paginationManager.toPageable());
      if (result.isSuccess()) {
        this.leaveWordList = result.data.content;
        this.paginationManager.total = result.data.totalElements;
        this.totalPages = result.data.totalPages;
      } else {
        this.$toast(result.msg);
      }
    },
    handlePreviousPage() {
      if (this.paginationManager.currentPage === 1) {
        return false;
      }
      this.paginationManager.currentPage--;
      this.searchLeaveWords();
    },
    handleNextPage() {
      if (this.totalPages === this.paginationManager.currentPage) {
        return false;
      }
      this.paginationManager.currentPage++;
      this.searchLeaveWords();
    },
    //搜索留言
    handleSearchLeaveWord() {
      this.searchLeaveWords();
    },
    //取消搜索留言
    handleCancelSearch() {
      this.leaveWordQuery = new LeaveWordQuery();
      this.searchLeaveWords();
    },
    handleGoToDetailPage(id) {
      this.$router.push({
        path: 'detail',
        query: {
          id: id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.leave-word-list {
  background: $base-color-white;

  .van-divider {
    margin: 0 0;
  }

  .leave-word-list-content {
    padding: 10px 4% 0 4%;
    box-sizing: border-box;

    .van-row {
      padding-bottom: 10px;
    }

    &:hover {
      background-color: #f5f5f5;
    }


    .leave-word-list-content-title {
      font-size: 13px;
      color: $base-color-black;
      font-weight: bold;
      line-height: 1.5;

      .top {
        display: inline-block;
        background-color: rgb(56, 160, 250);
        width: 30px;
        height: 14px;
        line-height: 14px;
        text-align: center;
        margin-right: 5px;

        & span {
          font-size: $base-font-size-small;
          color: $base-color-white;
          transform: scale(0.8);
        }

      }
    }


    .phoneNumber-and-createdDate {
      span {
        font-size: 10px;
        color: grey
      }

      .phoneNumber {
        margin-left: 10px;
      }

      .createdDate {
        margin-right: 10px;
      }
    }
  }

  .pagination-row {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $base-color-white;
    box-shadow: 0 0 77.28px 6.72px rgba(0, 0, 0, 0.03);
    height: 60px;
    position: fixed;
    width: 100%;
    bottom: 0;

    div {
      color: $base-color-black;
      font-size: $base-font-size-big;
      margin: 0 30px;
    }

    img {
      width: 12px;
      height: 20px;
    }

  }
}


</style>